import { render, staticRenderFns } from "./PutAside.vue?vue&type=template&id=e9c9267a&scoped=true&lang=pug&"
import script from "./PutAside.vue?vue&type=script&lang=js&"
export * from "./PutAside.vue?vue&type=script&lang=js&"
import style0 from "./PutAside.vue?vue&type=style&index=0&id=e9c9267a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c9267a",
  null
  
)

/* custom blocks */
import block0 from "./PutAside.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports